module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Merishausen-579bfcee2b710d59fe407ff2c95e1e46.png";